module.exports = __webpack_public_path__ + "img/marmelaedchen-bild_xs.06eb573b.jpg";